import { render, staticRenderFns } from "./ViewComment.vue?vue&type=template&id=2e8ba592&scoped=true"
import script from "./ViewComment.vue?vue&type=script&lang=js"
export * from "./ViewComment.vue?vue&type=script&lang=js"
import style0 from "./ViewComment.vue?vue&type=style&index=0&id=2e8ba592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ba592",
  null
  
)

export default component.exports